import type { AdminSurface } from '@/lib/guards';

import type { RoleType } from './roles';

const CLAIM_ROLES: readonly RoleType[] = ['psychologist', 'chief_psychologist'];
const REASSIGN_ROLES: readonly RoleType[] = [
  'chief_psychologist',
  'ba_admin',
  'ba_super_admin',
  'super_admin',
];

/** BE: `telephony:claim` is granted to psychologist and chief_psychologist only. */
export function canClaimCall(role: RoleType | null): boolean {
  return role !== null && CLAIM_ROLES.includes(role);
}

/** BE: `telephony:dial` mirrors the claim roles: the session is the dialer's. */
export function canDialCall(role: RoleType | null): boolean {
  return role !== null && CLAIM_ROLES.includes(role);
}

/** BE: `telephony:reassign` (also gates reopen) for chiefs and admins. */
export function canReassignCall(role: RoleType | null): boolean {
  return role !== null && REASSIGN_ROLES.includes(role);
}

/**
 * BE: `did_mapping:manage` for ba_super_admin and super_admin. Mirror the
 * surface split: platform shows the screen to super_admin only, workspace to
 * ba_super_admin only, so nobody sees a form the BE would reject.
 */
export function canManageDidMappings({
  role,
  surface,
}: {
  role: RoleType | null;
  surface: AdminSurface;
}): boolean {
  if (role === null) return false;
  if (surface === 'platform') return role === 'super_admin';
  return role === 'ba_super_admin';
}
